import { render, staticRenderFns } from "./CompraAprovarAdminFretes.vue?vue&type=template&id=becf9b12"
import script from "./CompraAprovarAdminFretes.vue?vue&type=script&lang=js"
export * from "./CompraAprovarAdminFretes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports